import { render, staticRenderFns } from "./GeoAlloc.vue?vue&type=template&id=8227aa30&scoped=true&"
import script from "./GeoAlloc.vue?vue&type=script&lang=js&"
export * from "./GeoAlloc.vue?vue&type=script&lang=js&"
import style0 from "./GeoAlloc.vue?vue&type=style&index=0&id=8227aa30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8227aa30",
  null
  
)

export default component.exports